export default __webpack_public_path__ + "static/media/lefa_x_orelsan_1_lowdef.7f7827c3.png";